// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2hOgJ","col":"styles_col__2V-nZ"};